import Network from 'lib/api/network';

export default {
  namespaced: true,

  state() {
    return {
      incompatiblePairs: [],
      loading: false,
      hasPairingPreferencesName: false,
    };
  },

  mutations: {
    setIncompatiblePairs(state, pairs) {
      state.incompatiblePairs = pairs;
    },
    update(state, { key, value }) {
      state[key] = value;
    },
    setLoading(state, loading) {
      state.loading = loading;
    },
  },

  getters: {
    incompatiblePairs: (state) => state.incompatiblePairs,
    loading: (state) => state.loading,
    hasPairingPreferencesName: (state) => state.hasPairingPreferencesName,
  },

  actions: {
    fetchIncompatiblePairs({ commit, dispatch }, userId) {
      commit('update', { key: 'loading', value: true });

      const response = Network.get(`/users/${userId}/incompatible_pairs`, {
        success: (data) => {
          commit('update', { key: 'incompatiblePairs', value: data.incompatible_pairs });
        },
        error: (_error) => {
          dispatch('setErrorToast', 'Failed to fetch avoid list', { root: true });
        },
        complete: () => {
          commit('update', { key: 'loading', value: false });
        },
      });

      return response;
    },

    bulkUpdateIncompatiblePairs({ commit, dispatch }, { userId, invalidPartnerUids }) {
      commit('update', { key: 'loading', value: true });
      const response = Network.patch(`/users/${userId}/incompatible_pairs/bulk_upsert`, {
        invalid_partner_uids: invalidPartnerUids,
      }, {
        success: (data) => {
          commit('update', { key: 'incompatiblePairs', value: data.incompatible_pairs });
          dispatch('setSuccessToast', 'Successfully updated avoid list', { root: true });
        },
        error: (_error) => {
          dispatch('setErrorToast', 'Failed to update avoid list', { root: true });
        },
        complete: () => {
          commit('update', { key: 'loading', value: false });
        },
      });

      return response;
    },
  },
};
